(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ob-faq-page"] && !Shopify.designMode) return;
  try {
    
  /* One open at a time, first open on load. Same behaviour as the PDP and
     Contact accordion; scoped to [data-ob-faq] so each instance is independent.
     The first row ships with `open: true` from Liquid, so it is open before any
     JavaScript runs and stays open if JavaScript never does. */
  (function () {
    document.querySelectorAll('[data-ob-faq]').forEach(function (faq) {
      if (faq.dataset.obFaqBound === '1') return;
      faq.dataset.obFaqBound = '1';
      faq.addEventListener('click', function (e) {
        var btn = e.target.closest('.ob-faq__q');
        if (!btn || !faq.contains(btn)) return;
        var row = btn.closest('.ob-faq__row');
        var wasOpen = row.classList.contains('is-open');
        faq.querySelectorAll('.ob-faq__row').forEach(function (r) {
          r.classList.remove('is-open');
          var b = r.querySelector('.ob-faq__q');
          if (b) { b.setAttribute('aria-expanded', 'false'); }
        });
        if (!wasOpen) {
          row.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ob-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ob-faq]').forEach(function (faq) {
      var rows = faq.querySelectorAll('.ob-faq__row');
      faq.addEventListener('click', function (e) {
        var btn = e.target.closest('.ob-faq__q');
        if (!btn || !faq.contains(btn)) return;
        var row = btn.closest('.ob-faq__row');
        var wasOpen = row.classList.contains('is-open');
        rows.forEach(function (r) {
          r.classList.remove('is-open');
          var b = r.querySelector('.ob-faq__q');
          if (b) { b.setAttribute('aria-expanded', 'false'); }
        });
        if (!wasOpen) {
          row.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ob-size-guide-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initObSizeGuidePage(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('.obsgp');
      if (scope.classList && scope.classList.contains('obsgp')) {
        sections = [scope];
      }
      sections.forEach(function (section) {
        if (section.obsgpBound) { return; }
        section.obsgpBound = true;

        /* ---- Tab / pill navigation ---- */
        var tabs = section.querySelectorAll('[data-obsgp-tab]');
        var panels = section.querySelectorAll('[data-obsgp-panel]');

        function activate(key) {
          tabs.forEach(function (tab) {
            var on = tab.getAttribute('data-obsgp-tab') === key;
            tab.classList.toggle('is-active', on);
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.setAttribute('tabindex', on ? '0' : '-1');
          });
          panels.forEach(function (panel) {
            var on = panel.getAttribute('data-obsgp-panel') === key;
            panel.classList.toggle('is-hidden', !on);
            if (on) {
              panel.removeAttribute('hidden');
            } else {
              panel.setAttribute('hidden', '');
            }
          });
        }

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            activate(tab.getAttribute('data-obsgp-tab'));
          });
        });

        /* ---- In/Cm unit toggle (per panel) ---- */
        var toggles = section.querySelectorAll('[data-obsgp-toggle]');
        toggles.forEach(function (component) {
          var buttons = component.querySelectorAll('[data-obsgp-unit]');
          var panel = component.closest('[data-obsgp-panel]');
          if (!panel) { return; }
          var table = panel.querySelector('[data-obsgp-table]');
          var unitLabels = panel.querySelectorAll('[data-obsgp-unit-label]');
          buttons.forEach(function (button) {
            button.addEventListener('click', function () {
              var unit = button.getAttribute('data-obsgp-unit');
              buttons.forEach(function (btn) {
                var active = btn === button;
                btn.classList.toggle('is-active', active);
                btn.setAttribute('aria-pressed', active ? 'true' : 'false');
              });
              if (table) {
                table.querySelectorAll('[data-obsgp-in]').forEach(function (cell) {
                  var val = unit === 'cm' ? cell.getAttribute('data-obsgp-cm') : cell.getAttribute('data-obsgp-in');
                  var valEl = cell.querySelector('[data-obsgp-val]') || cell;
                  if (val !== null) { valEl.textContent = val; }
                });
              }
              unitLabels.forEach(function (label) {
                label.textContent = unit === 'cm' ? 'centimetres' : 'inches';
              });
            });
          });
        });
      });
    }
    initObSizeGuidePage(document);
    document.addEventListener('shopify:section:load', function (e) { initObSizeGuidePage(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
